import React, { useContext, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { CountdownMessage } from "@domestika-dev/prudencio/dist/atoms/CountdownMessage";
import { LiveSessionContext } from "../../../context/LiveSessionContext";
import { shouldShowCountdown } from "../../../utils/liveSessionStates";

export const PlayerCountdown = () => {
  const intl = useIntl();
  const { isTeacher, liveSession } = useContext(LiveSessionContext);
  const [countdownOverdue, setCountdownOverdue] = useState(false);

  const getCountdownMessages = useCallback(
    (showTeacherDueDateMessage) => ({
      message: intl.formatMessage({
        id: showTeacherDueDateMessage
          ? "live_sessions.video_player.lobby_teacher_countdown"
          : "live_sessions.video_player.countdown",
      }),
      daysLabel: intl.formatMessage({ id: "datetime.units.days_short" }),
      hoursLabel: intl.formatMessage({ id: "datetime.units.hours_short" }),
      minutesLabel: intl.formatMessage({ id: "datetime.units.minutes_short" }),
      secondsLabel: intl.formatMessage({ id: "datetime.units.seconds_short" }),
    }),
    []
  );

  return (
    shouldShowCountdown(liveSession?.aasmState) && (
      <CountdownMessage
        position="absolute"
        bottom={0}
        dueDate={new Date(liveSession?.scheduledAt).getTime()}
        showErrorOnEnd={isTeacher}
        onOverdue={() => setCountdownOverdue(true)}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...getCountdownMessages(isTeacher && countdownOverdue)}
      />
    )
  );
};

export default PlayerCountdown;
